module.exports = __webpack_public_path__ + "static/media/logo_wide.e902a37b.png";